import React, { useState } from "react";
import styled from "styled-components";
import PretendardText from "../atoms/text/pretendardText";
import { menuLang } from "../../lang/lang";
import { langState } from "../../store/langState";
import { useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import { routeV1 } from "../../pages/(v1)/route.v1";
import PreparedModal from "../../pages/modal/preparedModal";

const HeaderSubMenu = ({ list }) => {
  const language = useRecoilValue(langState);
  const navigation = useNavigate();
  const [isPreparedModal, setIsPreparedModal] = useState(false);

  return (
    <SubMenuWrapper>
      {list?.map((item, index) => {
        if (
          (item.originLink && item.subMenus3.length <= 0) ||
          item.exposure === false
        ) {
          return null;
        }
        return (
          <SubMenuTextWrapper key={index}>
            <SubMenuText
              onClick={() => {
                if (item.link === routeV1.faq) return;
                if (item.link === routeV1.stockInfo)
                  return setIsPreparedModal(true);
                navigation(item.link);
              }}
            >
              {item.title.startsWith("MENU")
                ? menuLang[item.title]?.[language] ?? item.title
                : item.title}
            </SubMenuText>
            <CrossLine />
            {/* 이하 서브 메뉴 렌더링 */}
          </SubMenuTextWrapper>
        );
      })}

      {isPreparedModal ? (
        <PreparedModal
          onClick={() => {
            setIsPreparedModal(false);
          }}
        />
      ) : null}
    </SubMenuWrapper>
  );
};

export default HeaderSubMenu;

const SubMenuWrapper = styled.div`
  width: 210px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 8px 8px 15px 0px rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 80px;
  left: -20px;

  z-index: 999;
`;

const SubMenuTextWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SubMenuText = styled(PretendardText)`
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  color: #5a636a;
  padding: 15px 15px;
  diplay: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &:hover {
    color: #00aeef;
  }
`;

const CrossLine = styled.div`
  border-bottom: 1px solid #f1f1f1;
  width: 180px;
`;
